import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/index';
import { utf8Encode } from '@angular/compiler/src/util';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {

    constructor(private httpClient: HttpClient) {
    }

    // TODO: check if we need to save rememberMe or not?
    loginUser(viewSessionId: string, username: string, password: string, rememberMe: boolean,
              accountAccessToken: string): Observable<any> {
        let headers;
        try {

            headers = new HttpHeaders({
                'Content-Type': 'application/json',
                Authorization: `Basic ${btoa(`${username}:${password}`)}`,
                'X-StatusOnLoginFail': '418'
            });

            if (viewSessionId !== undefined) {
                headers = new HttpHeaders({
                    'Content-Type': 'application/json',
                    Authorization: `Basic ${btoa(`${username}:${password}`)}`,
                    'View-Session-Id': `${viewSessionId}`,
                    'X-StatusOnLoginFail': '418'
                });
            }
        } catch(e) {

            // HACK: FOR DEV server not log in
            const escapeStr = btoa(utf8Encode(`${username}:${password}`)).replace('77u/', '');
            // console.log(escapeStr);

            headers = new HttpHeaders({
                'Content-Type': 'application/json',
                Authorization: `Basic ${escapeStr}`,
                'X-StatusOnLoginFail': '418'
            });

            console.log(e);
        }

        const accountAccessTokenParameter = accountAccessToken ? `?aat=${accountAccessToken}` : '';

        return this.httpClient
            .post< HttpResponse<any>>(`servlets/auth/login/${accountAccessTokenParameter}`,
                {username, password, rememberMe }, {observe: 'response', headers});
    }

    // NOT USED YET - just to show the concept
    loginViewSession(viewSessionId: string): Observable<any>  { // get ID from url for login-as from admin (backend creates new view session)
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'View-Session-Id': `${viewSessionId}`, // TODO: Make sure interceptor does not overwrite this (or perhaps that is ok when id is in state)
            'X-StatusOnLoginFail': '418'
        });

        return this.httpClient
            .post< HttpResponse<any>>('servlets/auth/login/viewsession/',
                {viewSessionId}, {observe: 'response', headers}); // TODO: Do we need this when ID is in header?
    }

    logoutUser(viewSessionId: string): Observable<any>  {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'View-Session-Id': `${viewSessionId}`
        });

        return this.httpClient
            .post('servlets/auth/logout/',
                {viewSessionId}, {observe: 'response', headers});
    }

    getLatestPortalVersion(viewSessionId: string): Observable<any> {
        return this.httpClient
            .post('servlets/auth/latestPortalVersion/',
                {viewSessionId}, {observe: 'body'});
    }
}
